import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import {
  CalculatorRepositoryModule,
  DocumentRepositoryModule,
  ParcelRepositoryModule,
  PolicyRepositoryModule,
} from '../client/repositories';
import { AddressChangeRequestModule } from '../client/repositories/address-change-request/address-change-request.module';
import { ClaimRepositoryModule } from '../client/repositories/claim/claim.module';
import { CustomerRequestRepositoryModule } from '../client/repositories/customer-request';
import { D3DocumentRepositoryModule } from '../client/repositories/d3-documents';
import { UserMessageRepositoryModule } from '../client/repositories/user-message';
import { UserRepositoryModule } from '../client/repositories/user/user.module';
import { ContentLayoutV2Component } from '../containers/layout/content-layout-v2.component';
import { ContentLayoutComponent } from '../containers/layout/content-layout.component';
import { NumberFormatterDirective } from './foundation/directives/number-format.directive';
import { PhoneFormatterDirective } from './foundation/directives/phone-format.directive';
import { ScrollSpyDirective } from './foundation/directives/scroll-spy.directive';
import { CurrencyValuePipe } from './pipes/currency.pipe';
import { DateValuePipe } from './pipes/date-value.pipe';
import { StrictValuePipe } from './pipes/strict-value.pipe';
import { TranslationMessagesPipe } from './pipes/translation-msg.pipe';

const MODULES: any[] = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NgbDatepickerModule,
  AngularSvgIconModule.forRoot(),
];

const SERVICES: any[] = [];

const MODULES_EXPORT = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NgbDatepickerModule,
  ClaimRepositoryModule,
  AddressChangeRequestModule,
  CustomerRequestRepositoryModule,
  DocumentRepositoryModule,
  ParcelRepositoryModule,
  ClaimRepositoryModule,
  CalculatorRepositoryModule,
  UserMessageRepositoryModule,
  UserRepositoryModule,
  PolicyRepositoryModule,
  D3DocumentRepositoryModule,
];

const COMPONENTS: any[] = [ContentLayoutComponent, ContentLayoutV2Component];

const DIRECTIVES = [
  ScrollSpyDirective,
  NumberFormatterDirective,
  PhoneFormatterDirective,
];

const PIPES = [
  TranslationMessagesPipe,
  StrictValuePipe,
  CurrencyValuePipe,
  DateValuePipe,
];

@NgModule({
  imports: [...MODULES],
  exports: [...DIRECTIVES, ...PIPES, ...COMPONENTS, ...MODULES_EXPORT],
  declarations: [...DIRECTIVES, ...PIPES, ...COMPONENTS],
  providers: [...SERVICES, ...PIPES],
})
export class SharedModule {}
